function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* global customElements, sessionStorage */
import FuturismElement from './futurism_element';
import FuturismTableRow from './futurism_table_row';
import FuturismLI from './futurism_li';
import { sha256 } from '../utils/crypto';

var polyfillCustomElements = function polyfillCustomElements() {
  if (customElements) {
    try {
      customElements.define('built-in', document.createElement('p').constructor, {
        "extends": 'p'
      });
    } catch (_) {
      document.write('<script src="//unpkg.com/@ungap/custom-elements-builtin"><\x2fscript>');
    }
  } else {
    document.write('<script src="//unpkg.com/document-register-element"><\x2fscript>');
  }
};

var defineElements = function defineElements(e) {
  if (!customElements.get('futurism-element')) {
    customElements.define('futurism-element', FuturismElement);
    customElements.define('futurism-table-row', FuturismTableRow, {
      "extends": 'tr'
    });
    customElements.define('futurism-li', FuturismLI, {
      "extends": 'li'
    });
  }
};

var cachePlaceholders = function cachePlaceholders(e) {
  sha256(e.detail.element.outerHTML).then(function (hashedContent) {
    e.detail.element.setAttribute('keep', '');
    sessionStorage.setItem("futurism-".concat(hashedContent), e.detail.element.outerHTML);
    e.target.dataset.futurismHash = hashedContent;
  });
};

var restorePlaceholders = function restorePlaceholders(e) {
  var inNamespace = function inNamespace(_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        _payload = _ref2[1];

    return key.startsWith('futurism-');
  };

  Object.entries(sessionStorage).filter(inNamespace).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        payload = _ref4[1];

    var match = /^futurism-(.*)/.exec(key);
    var targetElement = document.querySelector("[data-futurism-hash=\"".concat(match[1], "\"]"));

    if (targetElement) {
      targetElement.outerHTML = payload;
      sessionStorage.removeItem(key);
    }
  });
};

export var initializeElements = function initializeElements() {
  document.addEventListener('DOMContentLoaded', defineElements);
  document.addEventListener('turbo:load', defineElements);
  document.addEventListener('turbo:before-cache', restorePlaceholders);
  document.addEventListener('turbolinks:load', defineElements);
  document.addEventListener('turbolinks:before-cache', restorePlaceholders);
  document.addEventListener('cable-ready:after-outer-html', cachePlaceholders);
  polyfillCustomElements();
};